"use client";

import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Cart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2551" id="cart-content" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="flex flex-col gap-6 mb-16 md:mb-20 max-w-3xl">
            <div className="flex items-center gap-4">
              <span className="font-default text-xs uppercase tracking-[0.2em] text-secondary">
                § 01 — Order Review
              </span>
              <span aria-hidden="true" className="h-px flex-1 max-w-[120px]" style={{
              backgroundColor: "var(--primary)"
            }} />
            </div>

            <h1 className="font-default font-bold text-foreground text-[clamp(2.5rem,8vw,5.5rem)] leading-[1.0] tracking-tighter">
              Your Print Queue
            </h1>

            <p className="font-default text-lg text-secondary max-w-xl leading-relaxed">
              Review your selected DTF transfers and apparel items. Ensure your quantities and specifications are correct before initializing the production run.
            </p>

            <div className="flex items-center gap-3 mt-2">
              <span className="font-mono text-[0.7rem] uppercase tracking-[0.2em] text-secondary">
                ID / DTF—PRINT—QUEUE
              </span>
              <span className="h-px w-8 bg-border" aria-hidden="true" />
              <span className="font-mono text-[0.7rem] uppercase tracking-[0.2em] text-secondary">
                High-Fidelity Press
              </span>
            </div>
          </div>

          {}
          <div className="h-px w-full bg-border mb-12 md:mb-16" aria-hidden="true" />

          {}
          <div className="dtfprint-cart-wrapper">
            <WooCommerceCartBlock />
          </div>
        </div>
      </div>
    </section>;
}